<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5">
      <!-- Card stats -->

    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-body" v-if="ready">
              <!--Tables-->
              <terrain-details
              :terrainId="terrainId"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TerrainDetails from "@/views/Terrains/TerrainDetails/TerrainDetails.vue";

export default {
  components: {
    TerrainDetails
  },
  mounted(){
    this.terrainId = localStorage.getItem("terrainId")
    this.ready = true;
  },
  data(){
    return {
      terrainId: '',
      ready: false
    }
  }

};
</script>

<style></style>
